import * as React from 'react'
// eslint-disable-next-line import/no-cycle
import { cdnUrl } from 'utils/storyblok'
import MediaGroupComponent from './MediaGroup'

export const transformProps = (propsArg) => {
  const props = { ...propsArg }

  if (props.images) {
    props.images = props.images.map((image) => cdnUrl(image.filename))
  }

  return props
}
const MediaGroup = (props) => <MediaGroupComponent {...transformProps(props)} />

export default MediaGroup
